import { Component, Input } from "@angular/core";

@Component({
  selector: "app-asset-pipeline-mini",
  templateUrl: "./asset-pipeline-mini.component.html",
  styleUrl: "./asset-pipeline-mini.component.scss",
  standalone: false,
})
export class AssetPipelineMiniComponent {
  @Input() currentIndex: number = 1;
}
